import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import {Map, InfoWindow, Marker, GoogleApiWrapper} from 'google-maps-react';
import "./CarteDesDojos.css";
import { DojoRepository } from '../data/DojoRepository';
 
export class CarteDesDojos extends Component {
    state = {
        showingInfoWindow: false,
        activeMarker: {},
        selectedPlace: {},
    };

    onMarkerClick = (props, marker, e) => this.setState({
        selectedPlace: props,
        activeMarker: marker,
        showingInfoWindow: true
    });

    onMapClicked = (props) => {
        if (this.state.showingInfoWindow) {
            this.setState({
                showingInfoWindow: false,
                activeMarker: null
            })
        }
    };
    render() {
        return (
            <div class="container page-content">
                <div class="page-header">
                    <h2>Répertoire des dojos</h2> 
                </div> 
                <hr class="hrNeonBlue" />
                <p class="lead">Nous vous invitons à explorer le répertoire des dojos membres de Québec ISKF. Cliquez sur un marqueur ou dans la liste pour faire apparaître les détails d'un dojo et accéder à sa page individuelle.</p>
                <div class="row" id="quebec-iskf-map">
                    <div class="col-md-4 col-sm-4 map-container">
                        <ul id="dojos-list">
                        <li><Link to={DojoRepository.BELOEIL.url}>{DojoRepository.BELOEIL.city}</Link></li>
                            <li><Link to={DojoRepository.GASPE.url}>{DojoRepository.GASPE.city}</Link></li>
                            <li><Link to={DojoRepository.KINGSEY_FALL.url}>{DojoRepository.KINGSEY_FALL.city}</Link></li>
                            <li><Link to={DojoRepository.LES_ESCOUMINS.url}>{DojoRepository.LES_ESCOUMINS.city}</Link></li>
                            <li><Link to={DojoRepository.LEVIS.url}>{DojoRepository.LEVIS.city}</Link></li>
                            <li><Link to={DojoRepository.LONGUEUIL.url}>{DojoRepository.LONGUEUIL.city}</Link></li>
                            <li><Link to={DojoRepository.PRINCEVILLE.url}>{DojoRepository.PRINCEVILLE.city}</Link></li>
                            <li><Link to={DojoRepository.PREVOST.url}>{DojoRepository.PREVOST.city}</Link></li>
                            <li><Link to={DojoRepository.QUEBEC.url}>{DojoRepository.QUEBEC.city}</Link></li>
                            <li><Link to={DojoRepository.SEPT_ILES.url}>{DojoRepository.SEPT_ILES.city}</Link></li>
                            <li><Link to={DojoRepository.SAGUENAY.url}>{DojoRepository.SAGUENAY.city}</Link></li>
                            <li><Link to={DojoRepository.ST_ADOLPHE.url}>{DojoRepository.ST_ADOLPHE.city}</Link></li>
                            <li><Link to={DojoRepository.ST_JEAN_SUR_RICHELIEU.url}>{DojoRepository.ST_JEAN_SUR_RICHELIEU.city}</Link></li>
                            <li><Link to={DojoRepository.ST_JEROME.url}>{DojoRepository.ST_JEROME.city}</Link></li>
                            <li><Link to={DojoRepository.VAL_DAVID.url}>{DojoRepository.VAL_DAVID.city}</Link></li>
                            <li class="sublist-title">Montréal</li>
                            <li class="sublist"><Link to={DojoRepository.BLACK_DRAGON_MONTREAL.url}>{DojoRepository.BLACK_DRAGON_MONTREAL.city}</Link></li>
                            <li class="sublist"><Link to={DojoRepository.FIGHTER_ACADEMY.url}>{DojoRepository.FIGHTER_ACADEMY.city}</Link></li>
                            <li class="sublist"><Link to={DojoRepository.VILLE_ST_LAURENT.url}>{DojoRepository.VILLE_ST_LAURENT.city}</Link></li>
                        </ul>
                    </div>
                    <div class="col-md-8 col-sm-8 map-container" id="google-map">
                        <Map 
                            google={this.props.google}
                            initialCenter={{
                                lat: 48.00000,
                                lng: -69.80907
                            }}
                            zoom={5}
                            onClick={this.onMapClicked}>
                            <Marker onClick={this.onMarkerClick}
                                name={DojoRepository.BLACK_DRAGON_MONTREAL.name}
                                dojoPageUrl= {DojoRepository.BLACK_DRAGON_MONTREAL.url}
                                position={DojoRepository.BLACK_DRAGON_MONTREAL.geo} />
                            <Marker onClick={this.onMarkerClick}
                                name={DojoRepository.BELOEIL.name}
                                dojoPageUrl= {DojoRepository.BELOEIL.url}
                                position={DojoRepository.BELOEIL.geo} />
                            <Marker onClick={this.onMarkerClick}
                                name={DojoRepository.FIGHTER_ACADEMY.name}
                                dojoPageUrl= {DojoRepository.FIGHTER_ACADEMY.url}
                                position={DojoRepository.FIGHTER_ACADEMY.geo} />
                            <Marker onClick={this.onMarkerClick}
                                name={DojoRepository.GASPE.name}
                                dojoPageUrl= {DojoRepository.GASPE.url}
                                position={DojoRepository.GASPE.geo} />
                            <Marker onClick={this.onMarkerClick}
                                name={DojoRepository.KINGSEY_FALL.name}
                                dojoPageUrl= {DojoRepository.KINGSEY_FALL.url}
                                position={DojoRepository.KINGSEY_FALL.geo} />
                            <Marker onClick={this.onMarkerClick}
                                name={DojoRepository.LES_ESCOUMINS.name}
                                dojoPageUrl= {DojoRepository.LES_ESCOUMINS.url}
                                position={DojoRepository.LES_ESCOUMINS.geo} />
                            <Marker onClick={this.onMarkerClick}
                                name={DojoRepository.LEVIS.name}
                                dojoPageUrl= {DojoRepository.LEVIS.url}
                                position={DojoRepository.LEVIS.geo} />
                            <Marker onClick={this.onMarkerClick}
                                name={DojoRepository.LONGUEUIL.name}
                                dojoPageUrl= {DojoRepository.LONGUEUIL.url}
                                position={DojoRepository.LONGUEUIL.geo} />
                            <Marker onClick={this.onMarkerClick}
                                name={DojoRepository.LONGUEUIL.name}
                                dojoPageUrl= {DojoRepository.LONGUEUIL.url}
                                position={DojoRepository.LONGUEUIL.geo2} />
                            <Marker onClick={this.onMarkerClick}
                                name={DojoRepository.PREVOST.name}
                                dojoPageUrl= {DojoRepository.PREVOST.url}
                                position={DojoRepository.PREVOST.geo} />
                            <Marker onClick={this.onMarkerClick}
                                name={DojoRepository.PRINCEVILLE.name}
                                dojoPageUrl= {DojoRepository.PRINCEVILLE.url}
                                position={DojoRepository.PRINCEVILLE.geo} />
                            <Marker onClick={this.onMarkerClick}
                                name={DojoRepository.QUEBEC.name}
                                dojoPageUrl= {DojoRepository.QUEBEC.url}
                                position={DojoRepository.QUEBEC.geo} />
                            <Marker onClick={this.onMarkerClick}
                                name={DojoRepository.SAGUENAY.name}
                                dojoPageUrl= {DojoRepository.SAGUENAY.url}
                                position={DojoRepository.SAGUENAY.geo} />
                            <Marker onClick={this.onMarkerClick}
                                name={DojoRepository.SEPT_ILES.name}
                                dojoPageUrl= {DojoRepository.SEPT_ILES.url}
                                position={DojoRepository.SEPT_ILES.geo} />
                            <Marker onClick={this.onMarkerClick}
                                name={DojoRepository.ST_ADOLPHE.name}
                                dojoPageUrl= {DojoRepository.ST_ADOLPHE.url}
                                position={DojoRepository.ST_ADOLPHE.geo} />
                            <Marker onClick={this.onMarkerClick}
                                name={DojoRepository.ST_JEAN_SUR_RICHELIEU.name}
                                dojoPageUrl= {DojoRepository.ST_JEAN_SUR_RICHELIEU.url}
                                position={DojoRepository.ST_JEAN_SUR_RICHELIEU.geo} />
                            <Marker onClick={this.onMarkerClick}
                                name={DojoRepository.ST_JEROME.name}
                                dojoPageUrl= {DojoRepository.ST_JEROME.url}
                                position={DojoRepository.ST_JEROME.geo} />
                            <Marker onClick={this.onMarkerClick}
                                name={DojoRepository.VAL_DAVID.name}
                                dojoPageUrl= {DojoRepository.VAL_DAVID.url}
                                position={DojoRepository.VAL_DAVID.geo} />
                            <Marker onClick={this.onMarkerClick}
                                name={DojoRepository.VILLE_ST_LAURENT.name}
                                dojoPageUrl= {DojoRepository.VILLE_ST_LAURENT.url}
                                position={DojoRepository.VILLE_ST_LAURENT.geo} />

                            <InfoWindow
                            marker={this.state.activeMarker}
                            visible={this.state.showingInfoWindow}>
                                <div>
                                    <h3>{this.state.selectedPlace.name}</h3>
                                    <a href={this.state.selectedPlace.dojoPageUrl}>Plus d'informations</a>
                                </div>
                            </InfoWindow>
                        </Map>
                    </div>
                </div>
            </div>
        );
    }
}
 
export default GoogleApiWrapper({
  apiKey: ("AIzaSyCqdJMLfuasXIr2gfxOzJyfP1gXVQt5-H8")
})(CarteDesDojos)


// WEBPACK FOOTER //
// ./src/pages/dojo/CarteDesDojos.js